import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { User } from '../Permissions/AuthenticatedUser.context'
import { RootState } from './app.reducer'
import { injectTip } from './injectTip'
import { CustomTenantTheme, UserLicenses } from './app.api'

// https://developers.pendo.io/docs/?bash#initialization-and-identification
// https://developers.pendo.io/docs/?bash#functions

export const useTip = (user: User | null = null, theme: CustomTenantTheme | null = null, themeError: $TSFIXME | null = null): void => {
  const tipEnabled = useSelector(
    (state: RootState) => state.app.prerequisites?.tipEnabled ?? false,
  )
  const userLicenses = useSelector(
    (state: RootState) => state.app.userLicenses ?? null,
  )

  useEffect(() => {
    tipEnabled && injectTip()
  }, [tipEnabled])

  useEffect(() => {
    if (tipEnabled) {
      window.pendo.initialize()
      trackUser(user, theme, themeError, userLicenses)
    }
  }, [user, theme, themeError, tipEnabled, userLicenses])
}

//add this once your users are logged in/authenticate
const getPendoConfig = (user: User, theme: CustomTenantTheme | null, userLicenses: UserLicenses | null) => {
  const pendoUserId = user.tenantName + '-' + user.id
  const userHasScope = user.teamsInScope.length > 0

  return {
    visitor: {
      id: pendoUserId, // TenantId + UserID
      personId: user.id,
      tenantName: user.tenantName,
      team: user.teamName,
      tenantId: user.tenantId,
      c1Permissions: user.permissions,
      wfmPermissions: [], // these will be part of IAM service down the road
      localization: user.lang,
      timezone: user.timezoneString,
      c1Scoping: userHasScope,
      ...((theme?.oemTheme !== undefined && theme?.oemTheme !== null) ? { oemTheme: theme.oemTheme } : {}),
      c1UserLicenses: userLicenses?.licenses,
    },
    account: {
      id: user.pendoId,
    },
  }
}

const trackUser = (user: User | null, theme: CustomTenantTheme | null, themeError: $TSFIXME | null, userLicenses: UserLicenses | null) => {
  try {
    if (user && (theme || themeError) && userLicenses) {
      const pendoConfig = getPendoConfig(user, theme, userLicenses)
      window.pendo.updateOptions(pendoConfig)
    } else {
      window.pendo.clearSession?.()
      window.pendo.loadGuides?.()
    }
  } catch (e) {
    // eslint-disable-next-line no-console -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
    console.error('Error while loading TIP', e)
  }
}

const pendoEvents = {
  OPENED_MEDIAPLAYER: 'OPENED_MEDIAPLAYER',
} as const

export function track(event: string, props: Record<string, string>) {
  if (window.pendo?.isReady()) {
    window.pendo.track(event, props)
  }
}

export function trackOpenedMediaPlayer(props: Record<string, string>) {
  track(pendoEvents.OPENED_MEDIAPLAYER, props)
}

